var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4483 13.7687C32.9192 13.877 33.3889 13.583 33.4971 13.112C33.6054 12.6411 33.3113 12.1714 32.8404 12.0632L27.0517 10.7324C26.5807 10.6241 26.1112 10.9181 26.0029 11.3891C25.8947 11.86 26.1887 12.3296 26.6596 12.4379L32.4483 13.7687Z",
    fill: "url(#paint0_linear_1786_44833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 19.25C33.616 19.25 36.75 16.116 36.75 12.25C36.75 8.384 33.616 5.25 29.75 5.25C25.884 5.25 22.75 8.384 22.75 12.25C22.75 16.116 25.884 19.25 29.75 19.25ZM29.75 17.5C32.6495 17.5 35 15.1495 35 12.25C35 9.35051 32.6495 7 29.75 7C26.8505 7 24.5 9.35051 24.5 12.25C24.5 15.1495 26.8505 17.5 29.75 17.5Z",
    fill: "url(#paint1_linear_1786_44833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6809 8.08952C14.1144 6.74918 12.2196 6.61399 11.4586 7.85958L5.50621 17.6005C4.81958 18.7241 5.58729 20.1587 6.92641 20.2542L17.3095 20.9951C18.6486 21.0907 19.6228 19.7804 19.1118 18.5713L14.6809 8.08952ZM12.9593 8.76138C12.958 8.76295 12.9553 8.76628 12.9518 8.77205L7.00875 18.4979L7.01012 18.4988C7.01182 18.5 7.01452 18.5014 7.01918 18.503C7.02358 18.5046 7.03349 18.5074 7.05096 18.5086L17.434 19.2495C17.4515 19.2508 17.4622 19.2494 17.4676 19.2483C17.4734 19.2473 17.4774 19.2458 17.4807 19.2442C17.4849 19.2423 17.4891 19.2395 17.4928 19.2361L13.0691 8.77091C13.0674 8.76698 13.066 8.76435 13.0652 8.76269C13.06 8.75971 13.0442 8.75228 13.0182 8.75035C12.9893 8.74833 12.97 8.75473 12.9637 8.75779L12.9616 8.75901L12.9606 8.75989L12.9593 8.76138Z",
    fill: "url(#paint2_linear_1786_44833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9618 31.8141C33.5896 30.5887 34.7266 27.465 33.5012 24.8371C32.2758 22.2093 29.1522 21.0725 26.5244 22.2978L17.0081 26.7353C14.3802 27.9607 13.2434 31.0843 14.4687 33.7122C15.6941 36.34 18.8177 37.477 21.4456 36.2515L30.9618 31.8141ZM17.7477 28.3213C15.9958 29.1383 15.2378 31.2207 16.0547 32.9726C16.8717 34.7245 18.9541 35.4824 20.7061 34.6655L24.6138 32.8432L21.6558 26.4998L17.7477 28.3213ZM26.1998 32.1037L23.2415 25.7595L27.2639 23.8838C29.0158 23.0669 31.0983 23.8249 31.9152 25.5768C32.7321 27.3286 31.9741 29.4111 30.2222 30.228L26.1998 32.1037Z",
    fill: "url(#paint3_linear_1786_44833)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63299 19.2602C6.63299 19.2602 0.792605 35.4835 11.2021 34.043C21.6115 32.6025 36.8199 43.7766 38.4906 30.1672C40.1632 16.5579 37.6224 4.20845 32.2508 2.94662C26.8792 1.68479 13.4766 -1.44493 6.63299 19.2602Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44833",
    x1: 25.9805,
    y1: 10.71,
    x2: 28.138,
    y2: 15.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_44833",
    x1: 22.75,
    y1: 5.25,
    x2: 36.7487,
    y2: 19.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1786_44833",
    x1: 5.25,
    y1: 7,
    x2: 19.2488,
    y2: 21.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_44833",
    x1: 13.9756,
    y1: 21.8047,
    x2: 28.2959,
    y2: 40.9966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicines);
export default __webpack_public_path__ + "static/media/medicines.0ad07e4e60836559510e8e5548fd7fb6.svg";
export { ForwardRef as ReactComponent };